import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers } from 'lucide-react';
import { CTAButton } from './Shared';
export const Hero = () => {
  return <section className="relative bg-navy-900 text-white pt-12 md:pt-20 pb-12 md:pb-24 overflow-hidden" data-id="element-76">
      {/* Abstract background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-vbred/5 -skew-x-12 translate-x-20 pointer-events-none" data-id="element-77" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-6 md:space-y-8" data-id="element-79">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-vbred/10 text-vbred border border-vbred/20 rounded-full text-xs md:text-sm font-bold tracking-wider uppercase w-fit" data-id="element-80">
            <span className="w-2 h-2 rounded-full bg-vbred animate-pulse" data-id="element-81" />
            New Release
          </div>

          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase leading-[1.1] tracking-tight drop-shadow-md" data-id="element-82">
            Stop Spending Hours Planning{' '}
            <span className="text-vbred" data-id="element-83">Volleyball Practices</span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-[70%] mx-auto" data-id="element-84">
            <div className="absolute inset-0 bg-gradient-to-tr from-vbred/25 to-transparent blur-3xl -z-10 rounded-full" data-id="element-85" />
            <motion.img src="https://cdn.magicpatterns.com/uploads/eaqb19kyoyDZp6rC3AEpuf/Firefly_Gemini_Flash_quiero_que_me_adaptes_el_mockup_principal_a_los_colores_del_anuncio_que_te_pase_y_el_688253-Photoroom.png" alt="Volleyball Ready Pro Coaching System Mockup" className="w-full h-auto drop-shadow-2xl" animate={{
            y: [0, -12, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-86" />
          </motion.div>

          <p className="text-base md:text-xl text-gray-300 font-medium leading-relaxed max-w-2xl" data-id="element-87">
            Stop improvising every practice. 500 pages, 20 ready-to-use
            sessions, 40+ drills, 52 weeks of planning and everything a
            volleyball coach needs — prepared in minutes, executed with
            confidence.
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-xs md:text-sm font-semibold text-gray-300" data-id="element-88">
            <div className="flex items-center gap-2 bg-navy-800 px-3 md:px-4 py-2 rounded-md border border-white/5" data-id="element-89">
              <FileText className="w-4 h-4 text-vbgold" data-id="element-90" /> Digital PDF
            </div>
            <div className="flex items-center gap-2 bg-navy-800 px-3 md:px-4 py-2 rounded-md border border-white/5" data-id="element-91">
              <Zap className="w-4 h-4 text-vbgold" data-id="element-92" /> Instant Access
            </div>
            <div className="flex items-center gap-2 bg-navy-800 px-3 md:px-4 py-2 rounded-md border border-white/5" data-id="element-93">
              <Layers className="w-4 h-4 text-vbgold" data-id="element-94" /> 1 Complete Bible + 5
              Free Bonuses
            </div>
          </div>

          <div className="pt-2 md:pt-4 w-full flex justify-center" data-id="element-95">
            <CTAButton text="GET INSTANT ACCESS TO VOLLEYBALL READY PRO →" data-id="element-96" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="relative w-full max-w-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10 border-l-4 border-l-vbred mt-4 md:mt-8 rounded-xl" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/1LPYHKGYLN8rN5QZTfxvNS/Firefly_Gemini_Flash_Un_profe_de_volley_americano_mirando_a_la_camara_con_confianza_y_profesionalismo_688253.png" alt="Confident volleyball coach holding a ball on the court" className="w-full h-auto object-cover" data-id="element-98" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/60 to-transparent pointer-events-none" data-id="element-99" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8 text-left" data-id="element-100">
              <p className="italic font-medium text-white text-sm md:text-lg mb-2 md:mb-3 drop-shadow-lg" data-id="element-101">
                "When you have sessions ready, drills organized and a clear
                season plan — you stop wasting hours every week. And on the
                court, the difference shows immediately."
              </p>
              <p className="font-bold text-xs md:text-sm uppercase tracking-wide text-vbgold drop-shadow-md" data-id="element-102">
                — FastLearnersOfficial Coaching Team
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
};